module.exports = __webpack_public_path__ + "static/media/imagination.574fb9b1.png";